import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from 'sheets';

import styles from './PropQuote.css';

const PropQuote = (props) => {
  return (
    <div className={styles[`quote`]}>
      <p className={styles[`quote-copy`]}>&ldquo;{props.quote}&rdquo;</p>
      <Icon
        className={styles[`quote-logo`]}
        name={props.icon}
      />
    </div>
  );
};

PropQuote.propTypes = {
  icon: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
};

export default PropQuote;
